export default __webpack_public_path__ + "static/media/img-0620-monaco-half-face.497338e3.png";